
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { authorize } from '../../../services/authService';
import domtoimage from 'dom-to-image';

const ModalSeleccionarApariencia = () => {

  const { t } = useTranslation();
  const container = useRef(null);
  const [option, setOption] = useState('0');

// Obtener el nombre del usuario del sessionStorage
  const getUserName = () => {
    const toProperCase = (name) => {
      if (!name) return "Usuario";
      return name
          .split(/[\s]+/)
          .map(
              (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(' ');
    };
    const userInfo = sessionStorage.getItem('userinfo');
    if (userInfo) {
      const parsedUserInfo = JSON.parse(atob(userInfo));
      return toProperCase(parsedUserInfo.name);
    }
    return 'Usuario'; // Nombre predeterminado si no se encuentra el valor
  };

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = String(today.getFullYear());
    return `${day}/${month}/${year}`;
  };

  const handleOptionChange = (e) => {
    const { value } = e.target;
    setOption(value);

  };

  const handleAuthorize = () => {
    if (option === '0') {
      fillDefaultAppearance();
    } else {
      fillNoAppearance();
    }
  };

  const fillDefaultAppearance = () => {
    const element = container.current;
    element.style.border = 'none';
    element.style.boxShadow = 'none';

    domtoimage.toPng(element)
      .then(function (dataUrl) {
        const img = new Image();
        img.src = dataUrl;
        img.onload = () => {
          const appearance = JSON.parse(localStorage.getItem('appearance'));
          appearance.image.value = dataUrl;
          appearance.location.frame.upperRight.x = img.width / 2;
          appearance.location.frame.upperRight.y = img.height / 2;
          localStorage.setItem('appearance', JSON.stringify(appearance));
          callSignDocument();
        };
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }

  const fillNoAppearance = () => {
    const appearance = JSON.parse(localStorage.getItem('appearance'));
    appearance.image.value = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/aykKHkAAAAASUVORK5CYII=";
    appearance.location.frame.upperRight.x = 0.1;
    appearance.location.frame.upperRight.y = 0.1;
    localStorage.setItem('appearance', JSON.stringify(appearance));
    callSignDocument();
  }
  const getConfig = () => {
    const configEncoded = sessionStorage.getItem('configs');
    if (configEncoded) {
      const configDecoded = atob(configEncoded); // Decodificar base64
      return JSON.parse(configDecoded); // Parsear a JSON
    }
    return null; // Retorna null si no existe la configuración
  };

  const callSignDocument = async () => {
    const config = getConfig();
    if (config && config.SIGN_AUTH_REQUIRED ) {
      sessionStorage.setItem('sentToSign', 'true');
    }
    try {
      window.location.href = await authorize(
        process.env.REACT_APP_IDPID,
        process.env.REACT_APP_RESPONSE_TYPE,
        process.env.REACT_APP_STATE,
        process.env.REACT_APP_REDIRECT_URI
      );
    } catch (error) {
      console.error('Authorization failed', error);
    }
  }

  return (
    <div className="component-modal">

      {/* A partir de aca es el modal */}
      <div className="modal" id="modalSeleccionarApariencia">
        <div className="page-container">

          <div className="content-modal">

            {/* head modal */}
            <div className="header-modal">
              <h2 className="title-modal"> {t('signatureAppearance.signature-appearance')} </h2>
              <span className="close-modal"> &times; </span>
            </div>
            {/* head modal */}

            {/* body modal */}
            <div className="body-modal">

              <div className="modal-subtitle">
                <h3 className="txt">{t('signatureAppearance.select-option')}</h3>
                <button
                    type="button"
                    data-modal="modalDefinirApariencia"
                    className="btn-medium btn-primary modal-trigger"
                >
                  {t('signatureAppearance.add-appearance')}
                </button>

              </div>

              {/* Apariencias */}
              <div className="container-apariencias">

                <div className="apariencia-item">
                  <div className="a-header">
                    <p>{t('signatureAppearance.no-appearance')}</p>
                    <div className="form-group">
                      <input onChange={handleOptionChange} className="form-checkbox" id="no-appearance" type="radio" name="appearance" value="-1" />
                      <label className="form-label" htmlFor="no-appearance"></label>
                    </div>
                  </div>
                  <div className="a-view">
                  </div>
                </div>

                <div className="apariencia-item apariencia-item-selected">
                  <div className="a-header">
                    <p>{t('signatureAppearance.default-appearance')}</p>
                    <div className="form-group">
                      <input onChange={handleOptionChange} className="form-checkbox" id="default-appearance" type="radio" name="appearance" value="0" defaultChecked={true} />
                      <label className="form-label" htmlFor="default-appearance"></label>
                    </div>
                  </div>
                  <div className="a-view">
                    <div ref={container} className="a-content">
                      <div className="firma-apariencia size-pre">
                        <p className="name">{getUserName()}</p>
                        <p className="fecha">{getCurrentDate()}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Fin apariencias */}

              <div className="txt"> {t('signatureAppearance.appearance-summary')} </div>
            </div>
            {/* body modal */}

            {/* footer modal */}
            <div className="footer-modal">
              <div className="actions">
                <button type="button" className="btn-small btn-secondary modal-trigger" data-dismiss="modal"> {t('signatureAppearance.back')} </button>
                <button type="button" className="btn-small btn-primary" onClick={handleAuthorize}> {t('signatureAppearance.accept')} </button>
              </div>
            </div>
            {/* footer modal */}

          </div>

        </div>
      </div>
      {/* Fin del modal */}
      {/* Renderización condicional del segundo modal */}
    </div>
  );
};

export default ModalSeleccionarApariencia;
